var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "h-full relative",
      attrs: { "data-grm-comp": "RoomCBTView" },
    },
    [
      _c("div", { staticClass: "h-full bg-white flex" }, [
        _c("div", { staticClass: "min-w-0 flex-1" }, [
          _c("div", { staticClass: "h-full flex relative" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-full h-full p-4 flex flex-col overflow-y-auto lg:p-8",
              },
              [
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("div", { staticClass: "flex flex-col gap-y-2" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "w-max rounded-xl text-sm text-blue-400 leading-6 font-bold",
                      },
                      [_vm._v(_vm._s(_vm.$t("exam.question.title")))]
                    ),
                    _c("p", { staticClass: "text-xl font-bold" }, [
                      _vm._v(_vm._s(_vm.roomCBT.cbtTitle)),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex flex-col gap-y-2" }, [
                    _c("div", { staticClass: "flex flex-col gap-x-2" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "w-max rounded-xl text-sm text-blue-400 leading-6 font-bold",
                        },
                        [_vm._v(_vm._s(_vm.$t("exam.question.number")))]
                      ),
                      _c("p", { staticClass: "text-sm break-words" }, [
                        _vm._v(_vm._s(_vm.roomCBT.questionList?.length) + "개"),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "min-w-0 flex-1" },
                  _vm._l(_vm.roomCBT.questionList, function (question, i) {
                    return _c("RoomCBTQuestionChoice", {
                      key: question.questionId,
                      tag: "component",
                      attrs: { index: i, question: question },
                    })
                  }),
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }